// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { AiFillHome } from "react-icons/ai"; // Import the icon
// import "./Booking.css";

// const Booking = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     fullName: "",
//     email: "",
//     purpose: "",
//     phone: "",
//     remarks: "",
//   });

//   useEffect(() => {
//     // Scroll to the top when this component loads
//     window.scrollTo(0, 0);
//   }, []);


//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Form Submitted: ", formData);
//     alert("Form Submitted!");
//   };

//   const goHome = () => {
//     navigate("/"); // Redirect to home page
//   };

//   return (
//     <div className="booking-container">
//       <div className="mobile-close-btn" onClick={goHome}>
//         <AiFillHome size={24} />
//       </div>
//       <form className="booking-form" onSubmit={handleSubmit}>
//         <h2 className="form-title">Book a Meeting with our Team</h2>

//         <label>Full Name*</label>
//         <input
//           type="text"
//           name="fullName"
//           value={formData.fullName}
//           onChange={handleChange}
//           placeholder="Enter Your Name."
//           required
//         />

//         <label>Email ID*</label>
//         <input
//           type="email"
//           name="email"
//           value={formData.email}
//           onChange={handleChange}
//           placeholder="Enter your email."
//           required
//         />

//         <label>Purpose*</label>
//         <select
//           name="purpose"
//           value={formData.purpose}
//           onChange={handleChange}
//           required
//         >
//           <option value="">Select your purpose</option>
//           <option value="Consultation">Consultation</option>
//           <option value="Demo">Demo</option>
//           <option value="Support">Support</option>
//         </select>

//         <label>Phone Number*</label>
//         <input
//           type="tel"
//           name="phone"
//           value={formData.phone}
//           onChange={handleChange}
//           placeholder="Enter your Phone Number "
//           required
//         />

//         <label>Remarks</label>
//         <textarea
//           name="remarks"
//           value={formData.remarks}
//           onChange={handleChange}
//           placeholder="Give remarks"
//         />

//         <button type="submit" className="submit-btn">
//           Submit
//         </button>
//       </form>
//     </div>
//   );
// };

// export default Booking;

import React, { useState, useEffect } from "react";
import "./Booking.css";
import axios from "axios";

const Booking = ({ prefilledEmail = "", prefilledPurpose = "" }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: prefilledEmail,
    purpose: prefilledPurpose,
    phone: "",
    remarks: "",
  });

  // ✅ Update fields if props change
  useEffect(() => {
    if (prefilledEmail) {
      setFormData((prev) => ({ ...prev, email: prefilledEmail }));
    }
    if (prefilledPurpose) {
      setFormData((prev) => ({ ...prev, purpose: prefilledPurpose }));
    }
  }, [prefilledEmail, prefilledPurpose]);

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isValidPhone = (phone) => /^\d{10}$/.test(phone);
  const isValidName = (name) => /^[A-Za-z\s]+$/.test(name);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValidName(formData.fullName)) {
      alert("Please enter a valid name.");
      return;
    }
    if (!isValidEmail(formData.email)) {
      alert("Please enter a valid email.");
      return;
    }
    if (!isValidPhone(formData.phone)) {
      alert("Please enter a valid 10-digit phone number.");
      return;
    }

    try {
      const response = await axios.post(
        "https://wellwisemobile-h7bjesf2a4ajdxhe.centralindia-01.azurewebsites.net/api/session",
        {
          name: formData.fullName,
          email: formData.email,
          purpose: formData.purpose,
          phone_number: formData.phone,
          remarks: formData.remarks,
        }
      );

      if (response.status === 200 || response.status === 201) {
        alert("Form submitted successfully!");
        setFormData({
          fullName: "",
          email: prefilledEmail || "",
          purpose: prefilledPurpose || "",
          phone: "",
          remarks: "",
        });
      } else {
        alert("Failed to submit form. Please try again.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("An error occurred. Please try again later.");
    }
  };

  return (
    <div className="booking-container">
      <form className="booking-form" onSubmit={handleSubmit}>
        <h2 className="form-title">Book a Meeting with our Team</h2>

        <label>Full Name*</label>
        <input
          type="text"
          name="fullName"
          value={formData.fullName}
          onChange={handleChange}
          placeholder="Enter Your Name."
          required
        />

        <label>Email ID*</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Enter your email."
          required
        />

        {/* ✅ Purpose Dropdown */}
        <label>Purpose*</label>
        <select
          name="purpose"
          value={formData.purpose}
          onChange={handleChange}
          required
        >
          <option value="">Select your purpose</option>

          <option value="Ideation and Brainstorming">Ideation and Brainstorming</option>
          <option value="Electronics R&D">Electronics R&D</option>
          <option value="Mobile App Development">Mobile App Development</option>
          <option value="Website Development">Website Development</option>
          <option value="Cloud Technology">Cloud Technology</option>
          <option value="Content Creation & Marketing">Content Creation & Marketing</option>
        </select>

        <label>Phone Number*</label>
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          placeholder="Enter your Phone Number "
          required
        />

        <label>Remarks</label>
        <textarea
          name="remarks"
          value={formData.remarks}
          onChange={handleChange}
          placeholder="Give remarks"
        />

        <button type="submit" className="submit-btn">
          Submit
        </button>
      </form>
    </div>
  );
};

export default Booking;
